/**
 * OfertaSemAnuncios — tela 5 do funil Premium (após o intersticial, 1x/dia).
 *
 * Fonte: handoffAnuncios/PROMPT-claude-code.md § 5 e Monetizacao.dc.html (1e).
 * Título 36/800, sub 17 com "teste grátis" em primary, VITA premium-coroa 300
 * com 3 faíscas ✦ e flutuação de 4s, linha do sino, CTA amarelo e "Agora não".
 *
 * Sem teste disponível (`trialElegivel` false) a tela não promete teste: o
 * título vira a oferta do Premium, o sub não cita teste, a linha do sino some
 * e o CTA vira "Ver planos".
 *
 * X e "Agora não" → onFechar (segue o app). CTA → onAceitar.
 */

import React from 'react';
import haptics from '../../design/feedback/haptics';
import PainelPremium from './PainelPremium';
import PremiumTopBar from './PremiumTopBar';
import vitaCoroa from '../../Assets/images/vita/vita-premium-coroa.webp';
import s from './OfertaSemAnuncios.module.scss';

export default function OfertaSemAnuncios({ trialElegivel = true, trialDias = 7, onAceitar, onFechar }) {
  const aceitar = () => {
    haptics.light();
    onAceitar?.();
  };

  const titulo = trialElegivel ? `Sem anúncios por ${trialDias} dias` : 'Sem anúncios com o Turbo';

  return (
    <PainelPremium rotulo={titulo} brilho="centro" onFechar={onFechar}>
      <PremiumTopBar onFechar={onFechar} />

      <div className={s.corpo}>
        <h1 className={s.titulo}>{titulo}</h1>
        <p className={s.sub}>
          {trialElegivel ? (
            <>
              Comece seu <b className={s.destaque}>teste grátis</b> do Turbo!
            </>
          ) : (
            <>Use o app sem interrupções e com tudo do Turbo liberado.</>
          )}
        </p>

        <div className={s.palco} aria-hidden="true">
          <span className={s.brilho} />
          <span className={`${s.faisca} ${s.faisca1}`}>✦</span>
          <span className={`${s.faisca} ${s.faisca2}`}>✦</span>
          <span className={`${s.faisca} ${s.faisca3}`}>✦</span>
          <img className={s.vita} src={vitaCoroa} alt="" />
        </div>
      </div>

      <div className={s.rodape}>
        {trialElegivel && (
          <p className={s.aviso}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={s.sino}>
              <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.94 1.94 0 0 0 3.4 0" />
            </svg>
            A gente te avisa antes do teste acabar.
          </p>
        )}
        <button type="button" className={s.cta} onClick={aceitar}>
          {trialElegivel ? 'Assinar Turbo por R$0,00' : 'Ver planos'}
        </button>
        <button type="button" className={s.link} onClick={onFechar}>
          Agora não
        </button>
      </div>
    </PainelPremium>
  );
}
